import { memo, useMemo } from 'react'
import classNames from 'classnames'

import { TableDataViewCell, TableDataViewCellValue } from '@aytm/app/stats/page/question-views/components/table/types'

// styles
import style from '@aytm/app/stats/page/question-views/components/table/styles/Table.module.scss'

type TableCellValueProps = {
  cell: TableDataViewCell
  width: number | string
  position: number
  format?: (value: number | string) => number | string
}

type StylesProps = {
  flexGrow?: number
  flexShrink?: number
  flexBasis?: string
  width?: string
}

export default memo(TableCellValue)
export function TableCellValue(props: TableCellValueProps) {
  const cell = props.cell as TableDataViewCellValue

  const styles = useMemo(() => {
    const values: StylesProps = {}
    if ('width' in props && Number.isFinite(props.width)) {
      values.flexGrow = 0
      values.flexShrink = 0
      values.flexBasis = `${props.width}px`
      values.width = `${props.width}px`
    }
    if ('width' in props && 'string' == typeof props.width) {
      values.flexGrow = 0
      values.flexShrink = 0
      values.flexBasis = props.width
      values.width = props.width
    }
    return values
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.width])

  const cellValue = useMemo(
    () =>
      'loading' in cell && cell.loading
        ? null
        : 'format' in props && 'function' == typeof props.format
          ? props.format(cell.value)
          : cell.value,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [props.format, cell.value, cell.loading]
  )

  return (
    <div
      className={classNames(
        style['row-cell'],
        style['row-cell-value'],
        'classNames' in cell ? cell.classNames.map(className => style[className]).join(' ') : '',
        { [style['row-cell-value-active']]: 'onClick' in cell }
      )}
      title={'tooltip' in cell ? cell.tooltip : null}
      style={styles}
      onClick={'onClick' in cell ? () => cell.onClick(props.position) : null}
    >
      <span className={style['row-cell-value-text']} dangerouslySetInnerHTML={{ __html: String(cellValue) }} />
    </div>
  )
}
